import { render } from "./dashboard-component.vue?vue&type=template&id=1e55a822"
import script from "./dashboard-component.vue?vue&type=script&lang=js"
export * from "./dashboard-component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__